var Group = Chaplin.Model.extend({

});

module.exports = Group;
